var map = {
	"./game_logo_en.png": 7962,
	"./game_logo_jp.png": 5084,
	"./game_logo_kr.png": 7383,
	"./game_logo_zh-tw.png": 4524,
	"./game_logo_zh.png": 3078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4264;